<div *ngIf="isSummary" class="title">{{labels.businessRepresentatives}}</div>
<div
  class="representative-list-component-root"
  [ngClass]="{ summary: isSummary }"
  *transloco="let t">
  <div class="list">
    <div class="loading-container" *ngIf="listLoading">
      <mat-spinner [diameter]="60" class="spinner"></mat-spinner>
    </div>
    <app-representative-list
      [generalizedRepresentativeList]="getGeneralizedRepresentativeList()"
      [expiredTip]="labels.invitationExpired"
      (promote)="openConfirmPromotionDialog($event)"
      (remove)="openConfirmDeleteDialog($event)"
      (resendInvite)="openConfirmResendInviteDialog($event)"
      [labels]="representativeItemLabels"
      [canTamper]="true"
      *ngIf="!listLoading"
      [isSummary]="isSummary"
      [isSingleAdmin]="isSingleAdmin"
    >
    </app-representative-list>
  </div>
  <div class="invite-area">
    <app-label-prompt-button
      [formGroup]="manageRepresentatives"
      abstractControlName="email"
      [inputLabel]="labels.emailAddress"
      [buttonLabel]="labels.inviteBusinessRepresentative"
      [title]="labels.inviteABusinessRepresentative"
      (submitAction)="inviteBusinessRepresentative()"
      [buttonDisabled]="isInviteRepresentativeButtonDisabled()"
      [inputDisabled]="false"
      [errorMsg]="t(inviteErrorFeedback.feedback)"
    >
    </app-label-prompt-button>
  </div>
</div>
